import { createFileRoute, Outlet, redirect } from '@tanstack/react-router'
import { featureFlags } from '@/lib/feature-flags'

export const Route = createFileRoute('/_protected/knowledge')({
  beforeLoad: () => {
    if (!featureFlags.knowledge) {
      throw redirect({ to: '/' })
    }
  },
  component: Outlet,
})
